import React, { createContext, useContext, useState, useCallback } from 'react';

interface SoftphoneContextType {
  isOpen: boolean;
  openSoftphone: () => void;
  closeSoftphone: () => void;
  toggleSoftphone: () => void;
}

const SoftphoneContext = createContext<SoftphoneContextType | undefined>(undefined);

export const useSoftphoneContext = () => {
  const context = useContext(SoftphoneContext);
  if (!context) {
    // Return default values when context is not available
    return {
      isOpen: false,
      openSoftphone: () => {},
      closeSoftphone: () => {},
      toggleSoftphone: () => {},
    };
  }
  return context;
};

export const SoftphoneContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openSoftphone = useCallback(() => {
    console.log('SoftphoneContext: Opening softphone globally, current state:', isOpen);
    setIsOpen(true);
    console.log('SoftphoneContext: State set to true');
  }, [isOpen]);

  const closeSoftphone = useCallback(() => {
    console.log('SoftphoneContext: Closing softphone globally, current state:', isOpen);
    setIsOpen(false);
    console.log('SoftphoneContext: State set to false');
  }, [isOpen]);

  const toggleSoftphone = useCallback(() => {
    console.log('SoftphoneContext: Toggling softphone globally, current state:', isOpen);
    setIsOpen(prev => !prev);
    console.log('SoftphoneContext: State toggled');
  }, [isOpen]);

  const value: SoftphoneContextType = {
    isOpen,
    openSoftphone,
    closeSoftphone,
    toggleSoftphone,
  };

  return (
    <SoftphoneContext.Provider value={value}>
      {children}
    </SoftphoneContext.Provider>
  );
};